// Single source of truth for the Compliance section's tab order + sub-modes.
//
// The ordered array below IS the contract: tab index = position in the array.
// ComplianceView renders its <Tab>s from it, GlobalNavigation builds its sidebar
// sub-tabs from it, and the File/Tools menus + e-pilot deep-links address tabs by
// the named COMPLIANCE_TABS indices — so reordering a tab is a one-line change here
// instead of five hand-edited magic numbers across the codebase.
//
// FE-only: the backend (agent_service.py e-pilot nav map) uses raw ints and cannot
// import this, so it is NOT under check_constant_sync — keep it in sync by hand.

export const COMPLIANCE_TAB_ORDER = [
  { key: 'standards', label: 'Standards' },
  { key: 'status', label: 'Compliance Status' },
  { key: 'conformance', label: 'Conformance' },
  { key: 'risk', label: 'Risk Analysis' },
  { key: 'designReview', label: 'Design Review Gates' },
  { key: 'reports', label: 'Reports' },
];

// Named index per tab, derived from the order array (positional).
export const COMPLIANCE_TABS = COMPLIANCE_TAB_ORDER.reduce((map, tab, index) => {
  map[tab.key] = index;
  return map;
}, {});

// Sub-modes reached inside a parent tab, fed via the initialSubTab deep-link prop.
export const CONFORMANCE_MODE = { findings: 0, coverage: 1 };
export const COMPLIANCE_STATUS_SUBTAB = { current: 0, history: 1 };
export const REPORTS_SUBTAB = { doc: 0, technicalFile: 1, auditPackage: 2, designHistoryFile: 3, auditTrail: 4 };
